import { Box } from '@mui/material';
import { PickersActionBarProps } from '@mui/x-date-pickers/PickersActionBar';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../button';

export const CustomActionBar: FC<PickersActionBarProps> = ({ onClear }) => {
  const { t } = useTranslation();

  return (
    <Box className="flex justify-end gap-2 p-4 border-t border-grey-100">
      <Button onClick={onClear} variant="tertiary" size="small">
        {t('common:RESET')}
      </Button>
    </Box>
  );
};
